import {
  PublicationListOrderingKey,
  PublicationListOrderingValue,
} from "@/components/business/PublicationListContainer/publicationList.types";
import { usePublicationListFilterValue } from "@stores/publicationList";

export const useGetPublicationListFilterData = () => {
  const publicationListFilter = usePublicationListFilterValue();

  const {
    search,
    page,
    pageLimit,
    status,
    topicType,
    order,
    publishable,
    isTranslated,
  } = publicationListFilter;

  const updateOrder = Object.entries(order).map(
    ([key, value]): {
      sortBy: PublicationListOrderingKey;
      sortOrder: PublicationListOrderingValue;
    } => ({
      sortBy: key as PublicationListOrderingKey,
      sortOrder: value as unknown as PublicationListOrderingValue,
    }),
  );

  const publicationListFilterListForUpdate = {
    page,
    size: pageLimit,
    filter: {
      topicType,
      draftArticleStatusHighest: status,
      ...(publishable === "true" && { publishable }),
      ...(isTranslated === "true" && { hasTranslateParentId: isTranslated }),
      ...(search && {
        search: Object.entries(search)
          .filter(([, value]) => value && value.trim() !== "")
          .map(([key, value]) => {
            const typeMap: Record<string, string> = {
              allInfo: "allInfo",
              publicationIdInfo: "publicationIdInfo",
              doiInfo: "doiInfo",
              pmidInfo: "pmidInfo",
              titleInfo: "titleInfo",
              affiliationInfo: "affiliationInfo",
              allEditorInfo: "allEditorInfo",
              mcEditorInfo: "mcEditorInfo",
              ftEditorInfo: "ftEditorInfo",
            };
            return {
              type: typeMap[key] as any,
              keyword: value,
            };
          }),
      }),
    },
    order: [...updateOrder],
  };

  return publicationListFilterListForUpdate;
};
